import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ApiLoginService } from '@app/api/api-login.service';
import { ApiContentService } from '@app/api/api-content.service';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-adminsales-orderappsonly',
  templateUrl: './adminsales-orderappsonly.component.html',
  styleUrls: ['./adminsales.component.css']
})
export class AdminsalesOrderappsonlyComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  constructor(
    public restApi:ApiPartnerService,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
    private router: Router, 
  ) { }
  
  formIdProduct = this.fb.group({
    productsource : [''],
  });
  formOrderstb = this.fb.group({
    partnerid: [''],
    noorder: [''],
    nogrf: [''],
    noiom: [''],
    sales_name: [''],
    quota: [''],
    ordertype: [4],
    orderdate: [''],
    product: [''],
    ftthflag: ['']
  })
  formProduct = this.fb.group({
    productid : [''],
    transactiontype: [''],
    note: [''],
    quota: ['']
  });

  btn_save = true
  btn_loading = false
  alert_failed = false
  alert_success = false
  alert_redirect = false
  alert_quota = false
  table_product_kosong = true
  table_product_data = false
  
  selectedProduct: any = []
  data_table_product: any = []
  data_productsource:any={}
  data_partner:any=[]
  data_product:any={}
  response_api:any={}
  partnerdetail:any={}
  loadingcompany = false;

  count:number = 0
  sum:number = 0

  ordertypeValue='';
  psearch='';

  ngOnInit() {
    this.LoadJsOrder.loadScriptOrderService()
    this.sourceProduct()
    this.partner()
    
  }
  refreshPage() {
    this.ngOnInit()
  }

  searchcompany(){
    this.loadingcompany = true;
    let params = '?nama='+this.psearch;
    this.restApi.GetViewpartnerless(params).subscribe((output: any) => { 
      this.data_partner = output.data;
      this.loadingcompany = false;
    }); 
  }

  sourceProduct() {
    this.restApi.GetProductsource().subscribe((data: any) => { 
      this.data_productsource = data
      // console.log(this.data_productsource)
    });  
  }
  partner() {
    this.restApi.GetViewpartnerless().subscribe((output: any) => { 
      this.data_partner = output.data
    });  
  }
  partnerdtl() {
    let id = this.formOrderstb.value.partnerid
    this.restApi.GetViewpartnerdetail(id).subscribe((output: any) => { 
      this.partnerdetail = output.data
    });  
  }

  remove(item:any) {
    this.data_table_product.splice(item, 1);
  }
  resetForm(){
    this.formProduct.reset()
  }
  resetTbl(){
    this.data_table_product = []

  }
  redirectListorder(params: any) {
    this.router.navigate([params]);
  }

  ordertype() {
    if (this.ordertypeValue  == "1") {
      
      // this.formRegister.get('partner').setValidators(this.formPartner['partner']);
      // this.formRegister.get('partner').setValue(""); 
      this.resetTbl()
    }
  }


  submitOrderappsonly(el: HTMLElement) {

    this.restApi.PostCreateOrderstbonly(this.formOrderstb.value)
      .subscribe((data: any) => { 
        this.response_api = data
        console.log(data)
        if (this.response_api.status == true) {

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
  
          this.alert_redirect = true
          setTimeout(()=>{
            this.redirectListorder("adminsales/listorderstbonly");
          }, 5000);
        } else {

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
          // this.loading_create = false
        }
      }
    );
  }


  submitOrderstbonly(el: HTMLElement) {

    this.restApi.PostCreateOrderstbonly(this.formOrderstb.value)
      .subscribe((data: any) => { 
        this.response_api = data
        console.log(data)
        if (this.response_api.status == true) {

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
  
          this.alert_redirect = true
          setTimeout(()=>{
            this.redirectListorder("adminsales/listorderstbonly");
          }, 5000);
        } else {

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
          // this.loading_create = false
        }
      }
    );
  }

}
